import { ICustomFieldDto } from '@pf/shared/util-platform';
import { asArraySafe } from '@pf/shared-utility';

export const ITEM_CRITICAL_FIELD_VALUE = 'true';

export function isCriticalCustomField(
    cf: ICustomFieldDto | undefined | null,
    criticalKey: string | null | undefined
): boolean {
    if (!criticalKey || !cf?.key) {
        return false;
    }
    return (
        cf.key === criticalKey &&
        String(cf.value ?? '') === ITEM_CRITICAL_FIELD_VALUE
    );
}

export function partitionCriticalCustomField(
    fields: ICustomFieldDto[] | undefined | null,
    criticalKey: string | null | undefined
): { criticalRow: ICustomFieldDto | undefined; rest: ICustomFieldDto[] } {
    if (!criticalKey) {
        return { criticalRow: undefined, rest: asArraySafe(fields) };
    }
    let criticalRow: ICustomFieldDto | undefined;
    const rest: ICustomFieldDto[] = [];
    for (const f of asArraySafe(fields)) {
        if (f.key === criticalKey) {
            if (isCriticalCustomField(f, criticalKey)) {
                criticalRow = criticalRow ?? f;
            } else {
                rest.push(f);
            }
        } else {
            rest.push(f);
        }
    }
    return { criticalRow, rest };
}

export function partitionHazardCodeCustomField(
    fields: ICustomFieldDto[] | undefined | null,
    hazardKey: string | null | undefined
): { hazardRow: ICustomFieldDto | undefined; rest: ICustomFieldDto[] } {
    if (!hazardKey) {
        return { hazardRow: undefined, rest: asArraySafe(fields) };
    }
    let hazardRow: ICustomFieldDto | undefined;
    const rest: ICustomFieldDto[] = [];
    for (const f of asArraySafe(fields)) {
        if (f.key === hazardKey) {
            if (!hazardRow) {
                hazardRow = f;
            } else {
                rest.push(f);
            }
        } else {
            rest.push(f);
        }
    }
    return { hazardRow, rest };
}
